(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizznova-main-product"] && !Shopify.designMode) return;
  try {
    
  function syncRzProductGalleryArrows(root, index, total) {
    if (!root) return;
    root.querySelectorAll('[data-rz-product-gallery-arrow]').forEach(function(button) {
      var direction = Number(button.getAttribute('data-rz-product-gallery-arrow')) || 0;
      button.disabled = direction < 0 ? index <= 0 : index >= total - 1;
    });
  }

  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-rz-product-thumb], [data-rz-product-dot]');
    if (thumb) {
      var root = thumb.closest('[data-rz-product-page]');
      var mediaId = thumb.getAttribute('data-media-id');
      root.querySelectorAll('[data-rz-product-thumb], [data-rz-product-dot]').forEach(function(item) {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === mediaId);
      });
      var mediaItems = Array.from(root.querySelectorAll('[data-rz-product-media]'));
      var selectedMedia = mediaItems.find(function(item) { return item.getAttribute('data-media-id') === mediaId; });
      var selectedIndex = Math.max(0, mediaItems.indexOf(selectedMedia));
      if (window.matchMedia('(max-width: 980px)').matches && selectedMedia) {
        root.querySelector('[data-rz-product-gallery]').scrollTo({ left: selectedMedia.offsetLeft, behavior: 'smooth' });
      } else {
        root.querySelector('[data-rz-product-gallery]').style.setProperty('--rz-slide-index', selectedIndex);
        mediaItems.forEach(function(item) {
          item.classList.toggle('is-active', item === selectedMedia);
        });
      }
      syncRzProductGalleryArrows(root, selectedIndex, mediaItems.length);
      return;
    }

    var galleryArrow = event.target.closest('[data-rz-product-gallery-arrow]');
    if (galleryArrow) {
      var arrowRoot = galleryArrow.closest('[data-rz-product-page]');
      var arrowGallery = arrowRoot && arrowRoot.querySelector('[data-rz-product-gallery]');
      var arrowItems = arrowGallery ? Array.from(arrowGallery.querySelectorAll('[data-rz-product-media]')) : [];
      if (!arrowRoot || !arrowGallery || arrowItems.length < 2) return;
      var currentIndex;
      if (window.matchMedia('(max-width: 980px)').matches) {
        currentIndex = Math.round(arrowGallery.scrollLeft / Math.max(arrowGallery.clientWidth, 1));
      } else {
        currentIndex = Math.max(0, arrowItems.findIndex(function(item) { return item.classList.contains('is-active'); }));
      }
      var direction = Number(galleryArrow.getAttribute('data-rz-product-gallery-arrow')) || 0;
      var nextIndex = Math.max(0, Math.min(arrowItems.length - 1, currentIndex + direction));
      var nextId = arrowItems[nextIndex].getAttribute('data-media-id');
      var nextDot = arrowRoot.querySelector('[data-rz-product-dot][data-media-id="' + nextId + '"]');
      if (nextDot) nextDot.click();
      return;
    }

    var zoom = event.target.closest('[data-rz-product-zoom]');
    if (zoom) {
      var lightbox = document.querySelector('[data-rz-product-lightbox]');
      var source = zoom.querySelector('img');
      if (!lightbox || !source) return;
      var lightboxImage = lightbox.querySelector('[data-rz-product-lightbox-image]');
      lightboxImage.src = source.currentSrc || source.src;
      lightboxImage.alt = source.alt || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      return;
    }

    var closeLightbox = event.target.closest('[data-rz-product-lightbox-close]');
    if (closeLightbox || event.target.matches('[data-rz-product-lightbox]')) {
      var openLightbox = document.querySelector('[data-rz-product-lightbox].is-open');
      if (openLightbox) {
        openLightbox.classList.remove('is-open');
        openLightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
      return;
    }

    var optionButton = event.target.closest('[data-rz-option-value]');
    if (optionButton) {
      var optionRoot = optionButton.closest('[data-rz-product-page]');
      var optionGroup = optionButton.closest('[data-rz-option-group]');
      var variantSelect = optionRoot && optionRoot.querySelector('[data-rz-product-variant-select]');
      if (!optionRoot || !optionGroup || !variantSelect || optionButton.disabled) return;
      var position = Number(optionGroup.getAttribute('data-option-position'));
      var currentOption = variantSelect.options[variantSelect.selectedIndex];
      var wanted = [currentOption.getAttribute('data-option-1'), currentOption.getAttribute('data-option-2'), currentOption.getAttribute('data-option-3')];
      wanted[position - 1] = optionButton.getAttribute('data-rz-option-value');
      var matching = Array.from(variantSelect.options).find(function(item) {
        return [1, 2, 3].every(function(index) { return !wanted[index - 1] || item.getAttribute('data-option-' + index) === wanted[index - 1]; });
      });
      if (!matching || matching.getAttribute('data-available') !== 'true') {
        matching = Array.from(variantSelect.options).find(function(item) {
          return item.getAttribute('data-option-' + position) === wanted[position - 1] && item.getAttribute('data-available') === 'true';
        });
      }
      if (!matching) return;
      variantSelect.value = matching.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var quantityButton = event.target.closest('[data-rz-quantity-change]');
    if (quantityButton) {
      var quantity = quantityButton.closest('[data-rz-quantity]');
      var input = quantity && quantity.querySelector('[data-rz-quantity-input]');
      if (!input) return;
      var change = Number(quantityButton.getAttribute('data-rz-quantity-change')) || 0;
      var nextValue = Math.max(Number(input.min) || 1, (Number(input.value) || 1) + change);
      input.value = nextValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.querySelectorAll('[data-rz-product-gallery]').forEach(function(gallery) {
    var root = gallery.closest('[data-rz-product-page]');
    var mediaItems = Array.from(gallery.querySelectorAll('[data-rz-product-media]'));
    if (!root || mediaItems.length < 2) return;
    var ticking = false;
    syncRzProductGalleryArrows(root, 0, mediaItems.length);
    gallery.addEventListener('scroll', function() {
      if (ticking || !window.matchMedia('(max-width: 980px)').matches) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        var index = Math.max(0, Math.min(mediaItems.length - 1, Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1))));
        var mediaId = mediaItems[index].getAttribute('data-media-id');
        root.querySelectorAll('[data-rz-product-thumb], [data-rz-product-dot]').forEach(function(thumb) {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === mediaId);
        });
        syncRzProductGalleryArrows(root, index, mediaItems.length);
        ticking = false;
      });
    }, { passive: true });
  });

  document.addEventListener('change', function(event) {
    var select = event.target.closest('[data-rz-product-variant-select]');
    if (!select) return;
    var root = select.closest('[data-rz-product-page]');
    var option = select.options[select.selectedIndex];
    var variantInput = root.querySelector('[data-rz-product-variant-id]');
    var price = root.querySelector('[data-rz-product-price]');
    var addButton = root.querySelector('.rz-product__add');
    var buyNowButton = root.querySelector('[data-rz-buy-now]');
    var available = option.getAttribute('data-available') === 'true';

    root.querySelectorAll('[data-rz-option-group]').forEach(function(group) {
      var position = Number(group.getAttribute('data-option-position'));
      var selectedValue = option.getAttribute('data-option-' + position);
      group.querySelectorAll('[data-rz-option-value]').forEach(function(button) {
        var value = button.getAttribute('data-rz-option-value');
        var candidateExists = Array.from(select.options).some(function(candidate) {
          if (candidate.getAttribute('data-available') !== 'true') return false;
          for (var index = 1; index <= 3; index += 1) {
            var expected = index === position ? value : option.getAttribute('data-option-' + index);
            if (expected && candidate.getAttribute('data-option-' + index) !== expected) return false;
          }
          return true;
        });
        button.classList.toggle('is-selected', value === selectedValue);
        button.setAttribute('aria-pressed', value === selectedValue ? 'true' : 'false');
        button.disabled = !candidateExists;
      });
    });

    if (variantInput) variantInput.value = option.value;
    if (price) price.textContent = option.getAttribute('data-price') || price.textContent;
    if (addButton) {
      addButton.disabled = !available;
      var textNode = Array.from(addButton.childNodes).find(function(node) {
        return node.nodeType === 3 && node.textContent.trim();
      });
      if (textNode) textNode.textContent = available ? ' Add to cart ' : ' Sold out ';
    }
    if (buyNowButton) buyNowButton.disabled = !available;
  });

  document.querySelectorAll('[data-rz-product-variant-select]').forEach(function(select) {
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizznova-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-rn-product-rail-section] [data-rn-scroll]');
    if (!button) return;
    var shell = button.closest('.rn-carousel-shell');
    var rail = shell && shell.querySelector('[data-rn-rail]');
    if (!rail) return;
    var direction = button.getAttribute('data-rn-scroll') === 'left' ? -1 : 1;
    rail.scrollBy({ left: direction * Math.max(rail.clientWidth * .85, 280), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizznova-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('product-recommendations[data-url]').forEach(function(section) {
    if (section.dataset.rzLoaded === 'true') return;
    section.dataset.rzLoaded = 'true';
    fetch(section.dataset.url)
      .then(function(response) { return response.ok ? response.text() : ''; })
      .then(function(text) {
        if (!text) return;
        var documentFragment = new DOMParser().parseFromString(text, 'text/html');
        var replacement = documentFragment.querySelector('#' + section.id);
        if (!replacement || !replacement.innerHTML.trim()) return;
        section.innerHTML = replacement.innerHTML;
        document.dispatchEvent(new CustomEvent('rz:products:rendered'));
      })
      .catch(function() {});
  });

  } catch(e) { console.error(e); }
})();
})();
